import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./view.css";
import {
  challenges_approve_status,
  challenges_revert_status,
  get_challenge_opportunity_list,
} from "../admin.api";
import Snackbar from "../../../components/snackbar/snackbar";
import Loader from "../../../components/loader/loader";
import jwtDecode from "jwt-decode";
export default function View(props) {
  const [data, setData] = useState({});
  const [isActive, setIsActive] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const selectedParam = useParams();
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const assetBaseUrl = (process.env.REACT_APP_BASE_URL || "").replace(
    /\/api\/?$/,
    ""
  );

  const getDetails = async (id) => {
    if (!id) return;
    try {
      setIsActive(true);
      const res = await get_challenge_opportunity_list();
      const found = Array.isArray(res)
        ? res.find((x) => String(x.id) === String(id))
        : null;
      const mapped = found
        ? {
          ...found,
          opportunity:
            found?.market_analysis_opportunity?.opportunity ??
            found?.market_analysis_opportunity_name ??
            found?.opportunity ??
            "",
          image:
            found?.image && assetBaseUrl
              ? `${assetBaseUrl}/${String(found.image).replace(/^\//, "")}`
              : found?.image || "",
          brochure:
            found?.brochure && assetBaseUrl
              ? `${assetBaseUrl}/${String(found.brochure).replace(/^\//, "")}`
              : found?.brochure || "",
        }
        : {};
      setData(mapped);
    } catch (error) {
      setData({});
      setSnackMessage(
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch challenge opportunity details"
      );
      setIsSnackError(true);
      setSnackOpen(true);
    } finally {
      setIsActive(false);
    }
  };

  useEffect(() => {
    getDetails(selectedParam.id);
  }, [selectedParam]);
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push("/challenges");
    }
  };
  const handleApproveStatus = () => {
    setIsActive(true);
    challenges_approve_status(selectedParam.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        getDetails(selectedParam.id);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(
          error?.response?.data?.message ||
            error?.message ||
            "Failed to approve"
        );
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const handleRevertStatus = () => {
    setIsActive(true);
    challenges_revert_status(selectedParam.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        getDetails(selectedParam.id);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(
          error?.response?.data?.message ||
            error?.message ||
            "Failed to reject"
        );
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  return (
    <div>
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <Loader open={isActive} />
      <div className="view-container">
        <span className="d-flex justify-content-between">
          <h6 className="mb-0 pt-2">
            <b>Challenge Opportunity Details</b>
          </h6>
        </span>
        <hr />
        <button
          type="button"
          className="btn btn-primary btn-sm  mb-3"
          onClick={(e) => {
            props.history.push("/challenges");
          }}
        >
          Back
        </button>
        <div className="data">
          <div className="row">
            <div className="col-3">Opportunity</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {data?.opportunity || "Not Available"}
            </div>
          </div>
          <div className="row">
            <div className="col-3">Title</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {data?.title || "Not Available"}
            </div>
          </div>

          <div className="row">
            <div className="col-3">Description</div>
            <div className="col-1">:</div>
            <div className="col-7">{data?.description || "Not Available"}</div>
          </div>

          <div className="row">
            <div className="col-3">Due Date</div>
            <div className="col-1">:</div>
            <div className="col-7 mou-bw">{data?.due_date || "Not Available"}</div>
          </div>

          <div className="row">
            <div className="col-3">Site URL</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {data?.site_url ? (
                <a href={data.site_url} target="_blank" rel="noreferrer">
                  {data.site_url}
                </a>
              ) : (
                "Not Available"
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-3">Status</div>
            <div className="col-1">:</div>
            <div className="col-7">{data?.status || "Not Available"}</div>
          </div>

          <div className="row">
            <div className="col-3">Brochure</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {data?.brochure ? (
                <a href={data.brochure} target="_blank" rel="noreferrer">
                  {String(data.brochure).split("/").pop()}
                </a>
              ) : (
                "Not Available"
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-3">Image</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {data?.image ? <img width={200} src={data.image} alt="" /> : "Not Available"}
            </div>
          </div>
          {adminType === 2 &&
            data &&
            (String(data?.status).toLowerCase() === "pending" ||
              String(data?.status) === "0") && (
            <div className="d-flex justify-content-center mt-4">
              <button
                type="button"
                className="btn btn-approve btn-success mr-2"
                onClick={handleApproveStatus}
              >
                Approve
              </button>
              <br />
              <button
                type="button"
                className="btn btn-reject btn-danger"
                onClick={handleRevertStatus}
              >
                Reject
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
